'use client';

import { Tile, Spinner } from '@/components';
import { CalendarIcon } from '@/icons';
import { useGovernanceCalendar } from '@/hooks/content/hooks/useGovernanceCalendar';
import { useLocalizedContentfulStrings } from '@/hooks/content/hooks/useLocalizedContentfulStrings';
import { GovernanceCalendarItem } from './GovernanceCalendarItem';
import { useMemo } from 'react';
import { isFuture } from 'date-fns';

export const GovernanceCalendar = () => {
  const { data: calendarItems, isLoading: isCalendarLocading } = useGovernanceCalendar();
  const { localize } = useLocalizedContentfulStrings();
  const preparedDates = useMemo(() => {
    return calendarItems?.filter((item) => isFuture(item.date)).slice(0, 4) || [];
  }, [calendarItems]);

  return (
    <Tile className="flex flex-col gap-y-4 p-7">
      <p className="text-grey-100 flex flex-row items-center gap-x-2">
        <CalendarIcon className="w-4 h-4" />
        {localize('governanceCalendarHeader')}
      </p>
      {isCalendarLocading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col lg:flex-row gap-x-6 gap-y-2">
          {preparedDates.map((day) => (
            <GovernanceCalendarItem {...day} key={day.eventName} />
          ))}
        </div>
      )}
    </Tile>
  );
};
